import { centsToCurrency } from '@mp/utils';

export const displayParking = (
  parkingFree?: boolean | null,
  parkingReimbursed?: boolean | null,
  parkingValidated?: boolean | null,
  parkingCost?: number | null,
): string => {
  if (parkingFree) {
    return 'Parking is free';
  }
  if (parkingReimbursed) {
    return `Parking is reimbursed • ${centsToCurrency(parkingCost || 0)} daily`;
  }
  if (parkingValidated) {
    return 'Parking is validated';
  }
  if (parkingCost !== undefined) {
    return `Parking is not reimbursed • ${centsToCurrency(parkingCost || 0)} daily`;
  }
  return '';
};
